export enum SUBSCRIPTION_TIER {
  LEGACY = 'Legacy',
  CAPTURE = 'Capture',
  COMPLY = 'Comply',
  CONSULT = 'Consult',
  PIONEERS = 'Pioneers'
}
